const axios = require('axios');

const sendTeamsCard = async (cardContent) => {
  const payload = {
    attachments: [
      {
        contentType: "application/vnd.microsoft.card.adaptive",
        content: cardContent
      }
    ]
  };

  try {
    await axios.post(process.env.TEAMS_WEBHOOK_URL, payload, {
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (error) {
    console.error('Erro ao enviar mensagem para o Teams:', error.message);
  }
};

const sendTeamsNotification = async ({brandName, siteUrl }) => {
  
  const card = {
    $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
    type: "AdaptiveCard",
    version: "1.4",
    body: [
      {
        type: "TextBlock",
        text: `🚨 ${brandName} - home`,
        weight: "Bolder",
        size: "Large"
      },
      {
        type: "TextBlock",
        text: "Erro na publicação!",
        isSubtle: true,
        spacing: "None"
      }
    ],
    actions: [
      {
        type: "Action.OpenUrl",
        title: "🔗 Acessar site",
        url: siteUrl
      }
    ]
  };

  await sendTeamsCard(card);
};

const sendTeamsMessage = async (message) => {
  const card = {
    $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
    type: "AdaptiveCard",
    version: "1.4",
    body: [
      {
        type: "TextBlock",
        text: `${message}`,
        weight: "Bolder",
        size: "Medium"
      }
    ]
  };

  await sendTeamsCard(card);
};

module.exports = { sendTeamsNotification, sendTeamsMessage };
